module.exports = __webpack_public_path__ + "static/media/5. Entrando, Óleo y resina en tela, 40 x 240cm c_u, díptico, 2018 copy.f6bf038d.png";